var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 5.40033L2.66667 4.067L6.33333 7.73367L8.66667 5.40033L10.6667 7.40033V1.33333H1.33333V5.40033ZM1.33333 7.28593V10.6667H3.40033L5.39053 8.67647L2.66667 5.9526L1.33333 7.28593ZM5.28593 10.6667H10.6667V9.28593L8.66667 7.28593L5.28593 10.6667ZM0.666667 0H11.3333C11.7015 0 12 0.29848 12 0.666667V11.3333C12 11.7015 11.7015 12 11.3333 12H0.666667C0.29848 12 0 11.7015 0 11.3333V0.666667C0 0.29848 0.29848 0 0.666667 0ZM8.33333 4.66667C7.78107 4.66667 7.33333 4.21895 7.33333 3.66667C7.33333 3.11438 7.78107 2.66667 8.33333 2.66667C8.8856 2.66667 9.33333 3.11438 9.33333 3.66667C9.33333 4.21895 8.8856 4.66667 8.33333 4.66667Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon05);
export default __webpack_public_path__ + "static/media/sidebar-icon-05.2bc18a21507b177ab09dad3a25343126.svg";
export { ForwardRef as ReactComponent };